/**
 * Project SKUs Section Component
 */

import { Package } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import type { ProjectSku } from '../types';

interface ProjectSkusSectionProps {
  skus: ProjectSku[];
  currency?: string;
}

export function ProjectSkusSection({ skus, currency = 'CAD' }: ProjectSkusSectionProps) {
  if (!skus || skus.length === 0) {
    return null;
  }

  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-CA', {
      style: 'currency',
      currency,
    }).format(amount);
  };

  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <Package className="h-4 w-4" />
          SKUs ({skus.length})
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          {skus.map((sku) => (
            <div
              key={sku.id}
              className="flex items-center justify-between p-2 rounded border bg-muted/30"
            >
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <code className="text-xs bg-muted px-1.5 py-0.5 rounded font-mono">
                    {sku.sku}
                  </code>
                  <span className="text-sm font-medium">{sku.name}</span>
                </div>
                {sku.description && (
                  <p className="text-xs text-muted-foreground mt-1">{sku.description}</p>
                )}
              </div>
              <div className="text-right">
                <div className="text-sm font-medium">Qty: {sku.quantity}</div>
                {sku.unitPrice !== undefined && (
                  <div className="text-xs text-muted-foreground">
                    {formatCurrency(sku.unitPrice)} each
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
